import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { Observable } from 'rxjs';

import { HA_APP_KEY } from '../client-config/client-config.model';
import { CLIENT_CONFIG_TOKEN } from '../client-config/client-config.token';
import { Page } from '../client-config/page.client-config';
import { UrlService } from '../navigation/url.service';

/**
 * @whatItDoes Adds X-Correlation-Id header to each http request.
 *
 * @description
 *
 * This interceptor sends X-Correlation-Id as a header for each api request, which is then added to IIS logs to provide better tracing between Vanilla and IIS request logs.
 *
 * @stable
 */

export function correlationIdInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const page = inject(Page);
    const urlService = inject(UrlService);
    const clientConfig = inject(CLIENT_CONFIG_TOKEN);
    const parsedUrl = urlService.parse(req.url);

    const correlationId = clientConfig[HA_APP_KEY]?.correlationId;
    if (correlationId && parsedUrl.hostname.endsWith(page.domain)) {
        req = req.clone({
            headers: req.headers.set('X-Correlation-Id', correlationId),
        });
    }

    return next(req);
}
